/** Turn an internal tool name (`draft_short_letter`) into a label ("Draft Short Letter"). */
export function prettifyToolName(name: string | null | undefined): string {
  if (!name) return "a tool";
  return name
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
